import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatDetail } from "@/lib/api";
import { toast } from "sonner";
import { Wallet, Loader2 } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("admin@vorbuch.de");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück");
      navigate("/app");
    } catch (err) {
      const msg = formatDetail(err.response?.data?.detail) || err.message;
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#F9F9F8]">
      <div className="hidden lg:block relative overflow-hidden bg-[#18322B]">
        <img
          alt=""
          src="https://images.pexels.com/photos/7794004/pexels-photo-7794004.jpeg"
          className="absolute inset-0 h-full w-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#18322B]/85 via-[#18322B]/70 to-transparent" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center">
            <img
              src="/vorbuch-logo.png"
              alt="vorbuch.de"
              className="h-[7.5rem] w-auto"
              data-testid="login-logo"
            />
          </div>

          <div className="max-w-md">
            <h1 className="font-display font-extrabold text-4xl leading-tight tracking-tight">
              Kontoauszüge & Belege.<br />Endlich aufgeräumt.
            </h1>
            <p className="mt-4 text-sm opacity-80 leading-relaxed">
              Laden Sie Kontoauszüge und Belege hoch – vorbuch.de ordnet sie automatisch der richtigen Firma und Buchung zu. Alle zwei Tage ein sauberer Abgleich, jederzeit als sortiertes PDF exportierbar.
            </p>
          </div>

          <div className="text-[11px] uppercase tracking-[0.2em] opacity-60">© vorbuch.de · Made for Germany</div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 sm:px-12 py-12">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="mb-8">
            <div className="text-[11px] uppercase tracking-[0.2em] text-[#5C5E60] mb-2">Anmelden</div>
            <h2 className="font-display font-extrabold text-3xl tracking-tight text-[#1A1A1A]">Willkommen zurück</h2>
            <p className="mt-2 text-sm text-[#5C5E60]">Melden Sie sich mit Ihren Zugangsdaten an.</p>
          </div>

          {error && (
            <div className="mb-4 rounded-md bg-[#FCE8E8] text-[#B31D1D] text-xs px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}

          <label className="block text-xs font-semibold text-[#1A1A1A] mb-1.5">E-Mail</label>
          <input
            data-testid="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2.5 border border-[#E6E6E4] rounded-md text-sm focus:outline-none focus:border-[#18322B] focus:ring-1 focus:ring-[#18322B] transition-colors duration-150"
            placeholder="ihre@firma.de"
          />

          <label className="block text-xs font-semibold text-[#1A1A1A] mb-1.5 mt-4">Passwort</label>
          <input
            data-testid="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2.5 border border-[#E6E6E4] rounded-md text-sm focus:outline-none focus:border-[#18322B] focus:ring-1 focus:ring-[#18322B] transition-colors duration-150"
            placeholder="••••••••"
          />

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="mt-6 w-full bg-[#18322B] hover:bg-[#21453B] text-white text-sm font-semibold px-4 py-2.5 rounded-md transition-colors duration-150 disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Anmelden
          </button>

          <div className="mt-6 text-center text-xs text-[#5C5E60]">
            Noch kein Konto?{" "}
            <Link to="/register" className="font-semibold text-[#18322B] hover:underline" data-testid="link-register">
              Jetzt registrieren
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
